import BaseTextArea from 'components/atoms/base-textarea';
import BaseButton from 'components/atoms/baseButton';
import { useTranslation } from 'react-i18next';
import { useState, type FC } from 'react';
import BaseRadioGroup from 'components/atoms/base-radio-group';
import i18n from 'infrastructure/i18n';
import DraggableModal from 'components/organisms/draggableModal';

import s from './styles.module.scss';

const OPTIONS = [
  i18n.t('messages.someoneElseUsedTheDevice'),
  i18n.t('messages.weightWasTakenAtInconsistentTimeOfDay'),
  i18n.t('messages.deviceErrorOccurred'),
  i18n.t('labels.other'),
];
const OPTIONS_VALUE = OPTIONS.map((option) => ({
  label: option,
  value: option,
}));

type Props = {
  isOpen: boolean;
  isLoading: boolean;
  onClose: () => void;
  onSuccess: (v: string) => void;
};

const ErroneousModal: FC<Props> = ({
  isOpen,
  isLoading,
  onClose,
  onSuccess,
}) => {
  const { t } = useTranslation();
  const [value, setValue] = useState<string>('');
  const [selectOption, setSelectOption] = useState<string | undefined>(
    undefined,
  );

  const isOtherOption = selectOption === OPTIONS[3];
  const disableSubmit = selectOption === undefined || (isOtherOption && !value);

  const handleCancel = () => {
    onClose();
    setSelectOption(undefined);
    setValue('');
  };
  const handleSubmit = async () => {
    if (selectOption === undefined || (isOtherOption && !value)) return;

    const message = isOtherOption ? value : selectOption;
    onSuccess(message);
    setSelectOption(undefined);
    setValue('');
  };

  return (
    <>
      {isOpen && (
        <DraggableModal
          title={t('labels.markReadingAsErroneous')}
          isOpen={isOpen}
          toggle={handleCancel}
          bodyClassName={s['modal-body']}
          modalClassName={s.modal}
          footerClassName={s['modal-footer']}
          footer={
            <>
              <BaseButton
                label={t('controls.cancel')}
                type="secondary"
                onClick={handleCancel}
                className={s.button}
                key={t('controls.cancel')}
              />
              <BaseButton
                label={t('controls.send')}
                onClick={handleSubmit}
                className={s.button}
                key={t('controls.send')}
                disabled={disableSubmit}
                loading={isLoading}
              />
            </>
          }
        >
          <div className={s.wrapper}>
            <div className={s.body}>
              <div className={s['text-wrapper']}>
                <p className={s.title}>
                  {t('labels.areYouSureYouWantMarkThisReadingAsErroneous')}
                </p>
                <p className={s['sub-title']}>
                  {t(
                    'labels.thisWillRemoveReadingToErroneousFolderTheActionCannotBeUndone',
                  )}
                </p>
              </div>
              <label htmlFor="erroneous-modal-text-area" className={s.label}>
                {t('labels.reasonOfMarking')}:
              </label>
              <div className={s['options-wrapper']}>
                <BaseRadioGroup
                  name=""
                  className={s['radio-group']}
                  options={OPTIONS_VALUE}
                  value={selectOption}
                  onChange={(opt) => setSelectOption(opt)}
                />
                {isOtherOption && (
                  <BaseTextArea
                    id="erroneous-modal-text-area"
                    disabled={isLoading}
                    value={value}
                    style={{ resize: 'vertical' }}
                    placeholder={t('labels.typeHereDetails')}
                    onChange={(newValue) => setValue(newValue)}
                  />
                )}
              </div>
            </div>
          </div>
        </DraggableModal>
      )}
    </>
  );
};

export default ErroneousModal;
